import { render, staticRenderFns } from "./AssigneesFilter.vue?vue&type=template&id=b45d1be2&"
import script from "./AssigneesFilter.vue?vue&type=script&lang=js&"
export * from "./AssigneesFilter.vue?vue&type=script&lang=js&"
import style0 from "./AssigneesFilter.vue?vue&type=style&index=0&id=b45d1be2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports